import React from 'react'

import TotalPreTax from './TotalPreTax'
import TaxCost from './TaxCost'
import TipCost from './TipCost'
import Items from './Items'
import AddItem from './AddItem'
import Calculations from './Calculations'
import Description from '../components/Description'
import Footer from '../components/Footer'

export default class App extends React.Component {
  render () {
    return (
      <div>
        <div className="wrapper">
          <h1 className="title">One Card</h1>
          <Description />
          <TotalPreTax />
          <TaxCost />
          <TipCost />
          <Items />
          <AddItem />
          <Calculations />
        </div>
        <Footer />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/containers/App.js
 **/